import React from "react";
import "./HealthTwoBestDeals.scss";
import { useCollection } from "../../../../firebase-files/hooks/useCollection";
import { useNavigate } from "react-router-dom";

const HealthTwoBestDeals = () => {
  const navigate = useNavigate();
  const { documents } = useCollection("products", ["newArrivals", "==", true]);

  // Filter products where status is "active"
  const activeDeals = documents
    ? documents.filter((doc) => doc.status === "active").slice(0, 4)
    : [];

  return (
    <div className="health-two-best-deals">
      <div className="deals-header">
        <h2 className="health-two-section-heading">
          Today's best deals for you!
        </h2>
        <span
          className="see-all-link"
          onClick={() => navigate("/products-two")}
        >
          See all products →
        </span>
      </div>

      <div className="deals-list">
        {activeDeals.map((deal, index) => (
          <div
            className="deal-card"
            key={index}
            onClick={() => {
              navigate(`/product-details-two/${deal.id}`);
            }}
          >
            {deal.offer && <span className="offer-tag">{deal.offer}</span>}
            <img src={deal.images[0]} alt={deal.name} />
            <div className="deal-info">
              <span className="category">{deal.category}</span>
              <h4>{deal.short_description}</h4>
              <div className="price-and-button">
                <button className="add-btn">+ Add to Cart</button>
                <div className="price-container">
                  <span className="price">₹{deal.price}</span>
                  {deal.originalPrice && (
                    <span className="original-price">
                      ₹{deal.originalPrice}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HealthTwoBestDeals;
